import React, { Component } from 'react';
import { AnnouncementItem } from './shared/AnnouncementItem';
import './Announcement.css';

import { getClient } from './shared/auth.js';

class Announcement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: []
    };
  }

  componentDidMount() {
    const keys = require('../gsa-creds.json');
    const sheet = require('../sheet.json');
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const query = `select * where A >= date '${year}-${month}-${day}'`;
    let sheetId = sheet.sheets.announcements;
    const url = `https://docs.google.com/spreadsheets/d/${sheet.id}/gviz/tq?tqx=out:json&tq=${encodeURIComponent(query)}&gid=${sheetId}`;
    getClient(keys, ["https://www.googleapis.com/auth/drive.readonly"]).then(client => {
      client.request({url})
        .then(res => res.data)
        .then(data => data.split(/setResponse\(|\);/)[1])
        .then(JSON.parse)
        .then(
          data => {
            const table = data.table;
            let items = [];
            const rows = table.rows;

            for(let rowNum in rows){
              let row = rows[rowNum].c;
              let item = {
                date: new Date(row[0]?.f),
                title: row[1]?.v,
                body: row[2]?.v,
                loc: row[3]?.v,
                link: row[4]?.v,
                linkText: row[5]?.v,
                displayDate: row[6]?.v
              };
              items.push(item);
            }

            this.setState({
              isLoaded: true,
              items: [...items].sort((a, b) => a.date - b.date)
            });
          }
        ).catch(
          error => {
            this.setState({
              isLoaded: true, 
              error
            })
          }
        )
      });
  }

  render() {
    const { error, isLoaded, items } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>Loading...</div>;
    } else {
      return (
        <div className="container container-fix">
        <h1>Announcements</h1>
        {items.length > 0 ? items.map((item, ind) => (
            <AnnouncementItem
              key={ind}
              date={item.date}
              title={item.title}
              body={item.body}
              moreInfo={item.moreInfo}
              image={item.image}
              link={item.link}
              linkText={item.linkText}
              locLink={item.locLink}
              displayDate={item.displayDate}
              loc={item.loc} />
          )) : 
          <h3>No Announcements Right Now!</h3>}
        </div>
      );
    }
  }
}

export default Announcement;